/*
  CUSTOM CODE: ADDED - scorciatoie nella ricerca.

  Mentre il cliente scrive, prima dei risultati di Shopify mettiamo un blocco
  «Vai diretto» se la ricerca e' una misura («50x70», «50 70», «a3»,
  «quadrato», «grande»...), un artista (con la sua foto), un tema o «regalo».
  Ognuna porta alla pagina Manifesti gia' filtrata, che e' molto meglio di una
  lista di prodotti pescati a caso nelle descrizioni.

  I dati degli artisti li scrive custom__search-start.liquid.
*/
(function () {
  if (window.__customSearchShortcuts) return;
  window.__customSearchShortcuts = true;

  var SIZES = [
    { v: '35x35cm', l: '35×35', w: 35, h: 35 },
    { v: '29,7x42cm', l: '29,7×42', sub: 'A3', w: 29.7, h: 42 },
    { v: '40x60cm', l: '40×60', w: 40, h: 60 },
    { v: '33x70cm', l: '33×70', w: 33, h: 70 },
    { v: '35x85cm', l: '35×85', w: 35, h: 85 },
    { v: '50x70cm', l: '50×70', w: 50, h: 70 },
    { v: '65x65cm', l: '65×65', w: 65, h: 65 },
    { v: '60x90cm', l: '60×90', w: 60, h: 90 }
  ];
  var GROUPS = [
    [/\ba3\b|29[,.]?7|\bpiccol/, ['29,7x42cm', '35x35cm'], 'Piccoli'],
    [/quadrat/, ['35x35cm', '65x65cm'], 'Quadrati'],
    [/\bgrand|\bextra/, ['50x70cm', '65x65cm', '60x90cm'], 'Grandi'],
    [/\blung|stretto|stretti|panoram/, ['33x70cm', '35x85cm'], 'Lunghi e stretti'],
    [/\bmedi/, ['40x60cm', '33x70cm', '35x85cm'], 'Medi']
  ];
  var THEMES = [
    [/\bmare|spiaggi|estate/, 'Mare'],
    [/amor|romantic|san valentin|coppia/, 'Amore'],
    [/vino|cocktail|negroni|spritz|cibo|cucina|caff/, 'Cibo e vino'],
    [/tarocc|oroscop|luna|sole/, 'Tarocchi'],
    [/music|canzon/, 'Musica'],
    [/archite|roma\b|citt/, 'Architettura'],
    [/animal|gatt|cane|cavall|tigre|giraff/, 'Animali'],
    [/ironi|divertent|frasi|scritt/, 'Frasi'],
    [/cinema|film/, 'Cinema'],
    [/viaggi|vacanz/, 'Viaggio'],
    [/natura|fiori|piant/, 'Natura']
  ];

  var data = null;
  function getData() {
    if (data) return data;
    try {
      data = JSON.parse(document.getElementById('SearchShortcutsData').textContent);
    } catch (e) {
      data = { base: '/collections/manifesti', artists: [], gift: '' };
    }
    return data;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function sizeUrl(values) {
    var p = new URLSearchParams();
    values.forEach(function (v) {
      p.append('filter.p.m.custom.dimensioni', v);
    });
    return getData().base + '?' + p.toString();
  }

  function build(q) {
    q = q.toLowerCase().trim();
    if (q.length < 2) return [];
    var out = [];

    // misura scritta: 50x70, 50 x 70, 50*70, 70x50, 29,7x42
    var m = q.match(/(\d{2,3}(?:[,.]\d)?)\s*(?:x|×|\*|per|\s)\s*(\d{2,3})/);
    if (m) {
      var a = Math.round(parseFloat(m[1].replace(',', '.')));
      var b = parseInt(m[2], 10);
      var hit = SIZES.filter(function (s) {
        return (Math.round(s.w) === a && s.h === b) || (Math.round(s.w) === b && s.h === a);
      })[0];
      if (hit) {
        out.push({
          ic: hit.l, t: 'Misura ' + hit.l + (hit.sub ? ' (' + hit.sub + ')' : ''),
          s: 'Tutti i manifesti ' + hit.l + ', con la cornice della stessa misura', u: sizeUrl([hit.v])
        });
      } else {
        out.push({
          ic: m[1] + '×' + m[2], t: 'Nessun manifesto ' + m[1] + '×' + m[2],
          s: 'Le misure che abbiamo: ' + SIZES.map(function (s) { return s.l; }).join(' · '), u: ''
        });
      }
    } else {
      GROUPS.some(function (g) {
        if (!g[0].test(q)) return false;
        out.push({
          ic: g[1].length + ' mis.', t: 'Manifesti ' + g[2].toLowerCase(),
          s: g[1].map(function (v) { return SIZES.filter(function (s) { return s.v === v; })[0].l; }).join(' · '),
          u: sizeUrl(g[1])
        });
        return true;
      });
    }

    // artisti
    var words = q.split(/\s+/).filter(function (w) { return w.length > 3; });
    (getData().artists || []).forEach(function (ar) {
      var n = (ar.n || '').toLowerCase();
      if (!n) return;
      if (n.indexOf(q) !== -1 || words.some(function (w) { return n.indexOf(w) !== -1; })) {
        var ini = ar.n.split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase();
        out.push({ ic: ini, av: true, img: ar.i || '', t: ar.n, s: 'Artista · tutte le opere', u: ar.u });
      }
    });

    // regalo
    if (/regal/.test(q) && getData().gift) {
      out.push({ ic: '🎁', t: 'Idee regalo', s: 'I manifesti che scegliamo per regalare', u: getData().gift });
    }

    // temi
    THEMES.forEach(function (th) {
      if (!th[0].test(q)) return;
      var p = new URLSearchParams();
      p.append('filter.p.m.custom.tema', th[1]);
      out.push({ ic: '#', t: 'Tema: ' + th[1], s: 'Tutti i manifesti a tema', u: getData().base + '?' + p.toString() });
    });

    return out.slice(0, 3);
  }

  function icon(it) {
    if (it.img) {
      return '<span class="sshort__ic is-av" style="background:#fff;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1);overflow:hidden;padding:0">' +
        '<img src="' + esc(it.img) + '" alt="" width="48" height="48" style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block"></span>';
    }
    return '<span class="sshort__ic' + (it.av ? ' is-av' : '') + '">' + esc(it.ic) + '</span>';
  }

  function render(container, q) {
    var old = container.querySelector('.sshort');
    if (old) old.remove();
    var items = build(q);
    if (!items.length) return;
    var box = document.createElement('div');
    box.className = 'sshort';
    box.innerHTML =
      '<p class="sshort__title">Vai diretto</p>' +
      items.map(function (it) {
        var inner =
          icon(it) +
          '<span class="sshort__txt"><b>' + esc(it.t) + '</b><small>' + esc(it.s) + '</small></span>' +
          (it.u ? '<span class="sshort__arr" aria-hidden="true">→</span>' : '');
        return it.u
          ? '<a class="sshort__item" href="' + esc(it.u) + '">' + inner + '</a>'
          : '<div class="sshort__item is-static">' + inner + '</div>';
      }).join('');
    container.insertBefore(box, container.firstChild);
  }

  function attach(ps) {
    if (ps.__shortcuts) return;
    ps.__shortcuts = true;
    var input = ps.querySelector('input[type="search"]');
    var results = ps.querySelector('.js-results-container');
    if (!input || !results) return;
    new MutationObserver(function () {
      if (results.querySelector('.sshort') && results.__q === input.value) return;
      results.__q = input.value;
      render(results, input.value);
    }).observe(results, { childList: true });
  }

  function init() {
    document.querySelectorAll('predictive-search').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
